export const STATUSES = {
  loading: 'loading',
  idle: 'idle',
  completed: 'completed',
  errored: 'errored',
};
